module.exports = "<div class=\"page-signin\" ng-cloak ng-init=\"showProfileAlert = true ;\">\n  <!-- widgets -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n  <div class=\"container margin-t20\">\n    <candidate-profile />\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/lawyer-profile/candidate-profile.html
// module id = 1226
// module chunks = 0